<div class="host-modify-price-house-picker">
  <div class="filters border-b border-c-gs border-solid">
    <div class="row flex items-start mb-[10px]" *ngIf="listOfGroupOption?.length">
      <div class="group mr-3">
        <div class="v4-filter-selectable" [class.selected]="groupId === null" (click)="onFilter('group', null)">
          {{ "price.batch.modal.house.filter.group_all" | translate }}
          <!-- 不限分组 -->
        </div>
      </div>
      <div class="v4-option-list">
        <div class="v4-option-item" *ngFor="let group of listOfGroupOption">
          <div
            style="background-color: #fff"
            class="v4-filter-selectable"
            [class.selected]="groupId === group.value"
            (click)="onFilter('group', group.value)"
          >
            {{ group.label }}
          </div>
        </div>
      </div>
    </div>
    <div class="row flex items-start mb-[10px]" *ngIf="listOfHouseTypeOption?.length">
      <div class="group mr-3">
        <div class="v4-filter-selectable" [class.selected]="typeId === null" (click)="onFilter('type', null)">
          {{ "price.batch.modal.house.filter.type_all" | translate }}
          <!-- 不限房型 -->
        </div>
      </div>
      <div class="v4-option-list">
        <div class="v4-option-item" *ngFor="let type of listOfHouseTypeOption">
          <div
            style="background-color: #fff"
            class="v4-filter-selectable"
            [class.selected]="typeId === type.value"
            (click)="onFilter('type', type.value)"
          >
            {{ type.label }}
          </div>
        </div>
      </div>
    </div>
    <div class="row flex items-start mb-[10px]" *ngIf="listOfTagOption?.length">
      <div class="group mr-3">
        <div class="v4-filter-selectable" [class.selected]="tagId === null" (click)="onFilter('tag', null)">
          {{ "price.batch.modal.house.filter.label_all" | translate }}
          <!-- 不限标签 -->
        </div>
      </div>
      <div class="v4-option-list">
        <div class="v4-option-item" *ngFor="let tag of listOfTagOption">
          <div
            style="background-color: #fff"
            class="v4-filter-selectable"
            [class.selected]="tagId === tag.value"
            (click)="onFilter('tag', tag.value)"
          >
            {{ tag.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="content py-4 max-h-[400px] overflow-y-auto">
    <!--    <div class="operate" *ngIf="mode === 'multiple'">-->
    <!--      <span class="text-primary cursor-pointer mr-3" (click)="onSelectAll()">-->
    <!--        {{ "price.batch.modal.house.opt.select_all" | translate }}-->
    <!--         全选 -->
    <!--      </span>-->
    <!--      <span class="text-primary cursor-pointer" (click)="selectedHouses.clear()">-->
    <!--        {{ "price.batch.modal.house.opt.cancel_select_all" | translate }}-->
    <!--         取消选择 -->
    <!--      </span>-->
    <!--    </div>-->

    <div class="list">
      <ng-container *ngIf="listOfHouse?.length; else empty">
        <div class="v4-layout-block" *ngFor="let type of listOfHouse">
          <div class="v4-layout-block-title">{{ type.house_type_title }}</div>
          <div class="v4-layout-block-content">
            <div class="v4-option-list">
              <div class="v4-option-item" *ngFor="let house of type.houses">
                <div
                  class="v4-option"
                  [class.selected]="selectedHouses.has(house.house_id)"
                  (click)="onSelect(house.house_id)"
                >
                  {{ house.house_title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #empty>
        <nz-empty></nz-empty>
      </ng-template>
    </div>
  </div>

  <div class="footer flex flex-row items-center justify-between">
    <div *ngIf="mode === 'multiple'">
      <a nz-button nzType="link" class="mr-3" (click)="onSelectAll()">{{
        "price.batch.modal.house.opt.select_all" | translate
      }}</a>
      <a nz-button nzType="link" (click)="selectedHouses.clear()">
        {{ "price.batch.modal.house.opt.cancel_select_all" | translate }}</a
      >
    </div>
    <div class="ml-auto">
      <button nz-button nzSize="large" class="mr-3" (click)="onCancel()">
        {{ "word.cancel" | translate }}
        <!-- 取消 -->
      </button>
      <button nz-button nzSize="large" nzType="primary" (click)="onConfirm()">
        {{ "word.confirm" | translate }}
        <!-- 确定 -->
      </button>
    </div>
  </div>
</div>
